import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const GroupsList = styled(motion.ul)`
  padding: 100rem 0 335rem;
  display: grid;
  gap: 160rem;
  grid-template-columns: 1fr;

  ${mediaTablet(`
    padding: 100rem 0 250rem;
  `)}

  ${mediaDesktop(`
    padding: 100rem 0 521rem;
  `)}
`;

export const Group = styled(motion.li)`
  display: grid;
  grid-template-rows: 1fr;
  gap: 160rem;
  counter-increment: GroupsList;
`;

export const GroupItem = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr;
`;

export const TextContainer = styled.div`
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding: 73rem 168rem;

  &::after {
    content: counters(GroupsList, '');
    width: 48px;
    height: 48px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    border-radius: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.white};
    font-weight: 700;
    background: ${colors.alizarinCrimson};
  }
`;

export const GroupItemListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  ${mediaTablet(`
    grid-template-columns: repeat(12, 1fr);
  `)}
`;

export const GroupItemList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 110rem 0 0;

  p {
    font-size: 64rem;
    font-weight: 600;
    padding: 94rem 0;

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }
  }

  ${mediaTablet(`
    padding: 0 0 0 235rem;
    grid-column: 6/13;
  `)}
`;
